import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { emptyArr, emptyObj } from '@beef/utils';
import { createSelector } from '@reduxjs/toolkit';
import format from 'date-fns/format';
import ru from 'date-fns/locale/ru';
import { REQUEST_STATUS, highSpeedVerification, popupSteps } from "../../constants/orderTariffFormPopup";
import { getQueryParams } from "../../utils";
import { getCurrentFormStep, getOrderTariffCommonData, getOrderTariffData, getOrderTariffTexts, getTargetTariffType } from "./legacy/orderTariffCommon";
export var getAddressData = function getAddressData(state) {
  return getOrderTariffData(state).userData || emptyObj;
};
export var getRegion = function getRegion(state) {
  return getOrderTariffCommonData(state).region || emptyObj;
};
export var getStatusConnection = function getStatusConnection(state) {
  return getAddressData(state).statusConnection;
};
export var getUserPhoneNumber = function getUserPhoneNumber(state) {
  return getAddressData(state).userPhoneNumber;
};
export var getFullAddress = function getFullAddress(state) {
  var addressData = getAddressData(state);
  var _getRegion = getRegion(state),
    label = _getRegion.label;
  var _ref = getOrderTariffTexts(state).placeholderAddressTexts || emptyObj,
    city = _ref.city,
    flat = _ref.flat,
    house = _ref.house;
  return "\n  ".concat(city).concat(label, ",\n  ").concat(addressData.street.label || 'улица не выбрана', ",\n  ").concat(house).concat(addressData.house.label || 'не выбран', ",\n  ").concat(flat).concat(addressData.flat || 'не выбрана', "\n   ");
};
export var getHighSpeedAvailableFlag = createSelector([getStatusConnection], function (status) {
  return status === REQUEST_STATUS.isHighSpeedAvailable || status === REQUEST_STATUS.isHighSpeedAvailableWithoutCalendarStep;
});
export var getHighSpeedAvailableFlagWithStep = function getHighSpeedAvailableFlagWithStep(state) {
  var statusConnection = getHighSpeedAvailableFlag(state);
  var currentStep = getCurrentFormStep(state);
  if (currentStep === popupSteps.addressRequestForm) {
    return statusConnection ? highSpeedVerification.withoutVerification : highSpeedVerification.withVerification;
  }
  return highSpeedVerification.withoutVerification;
};
export var getUserPhoneNumbers = function getUserPhoneNumbers(state) {
  var matched = getAddressData(state).userPhoneNumber.match(/(\d{3})(\d{3})(\d{2})(\d{2})/) || emptyArr;
  return "+7 ".concat(matched[1], " ").concat(matched[2], "-").concat(matched[3], "-").concat(matched[4]);
};
export var getOrderResult = function getOrderResult(state) {
  return getOrderTariffCommonData(state).orderResult || emptyObj;
};
export var getNumOrder = function getNumOrder(state) {
  return getOrderResult(state).numOrder;
};
export var getCreateOrderDate = function getCreateOrderDate(state) {
  var _getOrderResult = getOrderResult(state),
    date = _getOrderResult.date;
  return format(date, 'DD MMM YYYY, HH:mm', {
    locale: ru
  });
};
export var getConnectionAvailableFlag = createSelector([getStatusConnection], function (status) {
  return status === REQUEST_STATUS.isAvailable || status === REQUEST_STATUS.isHighSpeedAvailable || status === REQUEST_STATUS.isHighSpeedAvailableWithoutCalendarStep || status === REQUEST_STATUS.isExists || status === REQUEST_STATUS.alreadyInUse;
});
export var buildOrderQueryParams = createSelector([getTargetTariffType, getAddressData, getHighSpeedAvailableFlag], function (tariffData, userData, isHighSpeedAvailable) {
  return getQueryParams(_objectSpread(_objectSpread({
    inacId: tariffData.inacId,
    street: userData.street.label,
    streetId: userData.street.id,
    house: userData.house.label,
    houseId: userData.house.id,
    flat: userData.flat
  }, userData !== null && userData !== void 0 && userData.userPhoneNumber ? {
    contactPhone: userData.userPhoneNumber
  } : {}), {}, {
    isHighSpeedAvailable: isHighSpeedAvailable
  }));
});